import { useEffect, useRef } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { APP_NAME } from 'app-config'

import { getVariantAction } from 'root-redux/actions/common'
import { selectConfig } from 'root-redux/selects/common'
import { TAppDispatch } from 'root-redux/store/store'

import { getCohortByCountryCode } from 'helpers/getCohortByCountryCode'
import {
  InitialPageRequest,
  measureInitialPageRequest,
} from 'helpers/initialPagePerformance'
import { replaceCohortInUrl } from 'helpers/replaceCohortInUrl'

import { AppName, COHORT_QUERY_PARAM, Cohort } from 'root-constants'
import { TAppName } from 'root-types'

const DefaultCohorts: Record<TAppName, Cohort> = {
  [AppName.blessedPath]: Cohort.FLOW_1_INTRO_LONG_2248,
  [AppName.ayahPath]: Cohort.FLOW_AYAH_313,
  [AppName.karmaPath]: Cohort.KP_BS_13,
}

export const useSetVariant = (): void => {
  const dispatch: TAppDispatch = useDispatch()
  const config = useSelector(selectConfig)

  const requestedCohortRef = useRef<string | null>(null)

  useEffect(() => {
    if (!APP_NAME || !config) return

    const URLParams = new URLSearchParams(document.location.search)
    const cohortFromUrl = URLParams.get(COHORT_QUERY_PARAM)
    const initialCohort = cohortFromUrl || DefaultCohorts[APP_NAME]
    const cohortToUse = getCohortByCountryCode({
      cohort: initialCohort,
      countryCode: config.countryCode,
    })

    if (cohortToUse === requestedCohortRef.current) return

    requestedCohortRef.current = cohortToUse

    if (cohortToUse !== initialCohort) {
      replaceCohortInUrl(cohortToUse)
    }

    measureInitialPageRequest({
      name: InitialPageRequest.VARIANT,
      resourcePath: `/v1/flow/${APP_NAME}/variants`,
      request: () =>
        dispatch(
          getVariantAction({
            cohort: cohortToUse,
          }),
        ),
    })
  }, [config, dispatch])
}
